import React from "react";
import { motion } from "framer-motion";
import { FaChalkboardTeacher, FaBookReader } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./CoursesSection.css";
import nttImage from "../../assets/35.avif";
import pttImage from "../../assets/AdobeStock_126711992_Preview_edited.avif";

const courses = [
  {
    id: 1,
    image: nttImage,
    icon: <FaChalkboardTeacher />,
    title: "Nursery Teacher Training",
    subtitle: "Montessori Integrated",
    details: ["NTT | MTT | Pre-Primary Course", "Montessori | Play School Course"],
    tagline: "Kick-start your Teaching Career!",
    link: "/course/ntt-mttcourse",
    color: "rgb(0, 102, 205)",
  },
  {
    id: 2,
    image: pttImage,
    icon: <FaBookReader />,
    title: "Primary Teacher Training",
    subtitle: "In-Service Teacher Training",
    details: [],
    tagline: "Empowering future classroom leaders",
    link: "/course/ptt-course",
    color: "#ee5951",
  },
];

const CoursesSection = () => {
  return (
    <section className="courses-section">
      <div className="container">
        <motion.h2
          className="courses-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Our Courses
        </motion.h2>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <motion.div
              key={course.id}
              className="course-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.2 }}
              whileHover={{ scale: 1.04 }}
            >
              <div className="course-img">
                <img
                  src={course.image}
                  alt={`${course.title} at NIECCE`}
                  title={`${course.title} at NIECCE`}
                />
                <div
                  className="course-icon"
                  style={{ color: course.color }}
                >
                  {course.icon}
                </div>
              </div>

              <div className="course-content">
                <h4 className="course-tagline">{course.tagline}</h4>
                <h3 className="course-title" style={{ color: course.color }}>
                  {course.title}
                </h3>
                {course.subtitle && (
                  <p className="course-subtitle">({course.subtitle})</p>
                )}
                {course.details.map((item, i) => (
                  <p key={i} className="course-detail">
                    <em>{item}</em>
                  </p>
                ))}
                <Link to={course.link} className="read-more-btn">
                  Read More
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
